import React from "react";
import { makeStyles } from '@mui/styles';
import { t, setStore } from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "62px",
  },

}));

const Footer = (props) => {
  const classes = useStyles();

  return (
    <footer  className={classes.root}>
        <p>&copy; 2024 Donaldo Tromp</p>
    </footer>

  );
}

export default Footer;
